import { IFormBuilderForm } from "../../model/formBuilderForm";
import { IFormBuilderRow } from "../../model/formBuilderRow";

export interface IMoveRowActionPayload {
  key: string;
  prevIndex: number;
  nextIndex: number;
}

export interface IMoveRowAction {
  type: "MOVE_ROW";
  payload: IMoveRowActionPayload;
}

export function getMoveRowInverseAction(
  action: IMoveRowAction,
): IMoveRowAction {
  const { key, prevIndex, nextIndex } = action.payload;

  return {
    type: "MOVE_ROW",
    payload: {
      key,
      prevIndex: nextIndex > prevIndex ? nextIndex - 1 : nextIndex,
      nextIndex: prevIndex > nextIndex ? prevIndex + 1 : prevIndex,
    },
  };
}

function moveRow(
  form: IFormBuilderForm,
  prevIndex: number,
  nextIndex: number,
): IFormBuilderForm {
  if (
    prevIndex < 0 ||
    prevIndex >= form.children.length ||
    nextIndex < 0 ||
    nextIndex > form.children.length ||
    prevIndex === nextIndex
  ) {
    return form;
  }

  const rows: IFormBuilderRow[] = [];

  for (let i = 0; i < form.children.length; i++) {
    if (i === prevIndex) {
      continue;
    }
    
    if (i === nextIndex) {
      rows.push(form.children[prevIndex]);
    }
    
    rows.push(form.children[i]);
  }

  if (nextIndex === form.children.length) {
    rows.push(form.children[prevIndex]);
  }

  return {
    ...form,
    children: rows,
  };
}

export function applyMoveRowChange(form: IFormBuilderForm, action: IMoveRowAction): IFormBuilderForm {
  const { prevIndex, nextIndex } = action.payload;

  return moveRow(form, prevIndex, nextIndex);
}